import type {CSSProperties} from 'react';
import {font, space, weight} from '../scale.js';
import {wedgeExactRole} from './wedgeRoles.js';

export type WedgeConfirmLook = 'confirm-cancel';

const CONFIRM_LOOKS = new Set<string>(['confirm-cancel']);
export const isWedgeConfirmLook = (look: string): look is WedgeConfirmLook => CONFIRM_LOOKS.has(look);

/* Released confirmation Sheet (sign out, delete account, export your data): Cancel under the confirm bar is a bare full-width block
   with no fill and no border, 14px of padding, 15px medium type in the secondary ink and a 4px margin above it. It keeps the pointer
   cursor. The released button declared no font family, so it took the Wedge font from the page rule; the look declares none either.
   It reads the exact legacy roles, and the declaration order is the order of the source. The caller owns the label and the handler. */
const CANCEL_PAD = 14;

export function wedgeConfirmStyle(_look: WedgeConfirmLook): CSSProperties {
  return {
    display: 'block', width: '100%', background: 'none', border: 0, color: wedgeExactRole('labelSec'),
    fontSize: font.callout, fontWeight: weight.medium, padding: CANCEL_PAD, marginTop: space[1], cursor: 'pointer',
  };
}
